import { Link, useNavigate } from "react-router-dom";
import {
  FiArchive,
  FiBook,
  FiBookOpen,
  FiGrid,
  FiHome,
  FiLogOut,
  FiShoppingBag,
  FiUser,
} from "react-icons/fi";
import { FaAddressBook, FaListAlt } from "react-icons/fa";

interface SidebarItemProps {
  to: string;
  icon: any;
  label: string;
  onClick: () => void;
  role: "ADMIN" | "USER" | "CS";
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  to,
  icon,
  label,
  onClick,
  role,
}) => (
  <li className="hover:bg-blue-600 w-full cursor-pointer text-sm">
    <Link
      to={to}
      className="px-4 py-2 items-center gap-3 flex"
      onClick={role === "USER" ? onClick : () => {}} // Close sidebar only for USER role
    >
      {icon}
      {label}
    </Link>
  </li>
);

export const Sidebar: React.FC<{
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  role: "ADMIN" | "USER" | "CS";
}> = ({ isSidebarOpen, toggleSidebar, role }) => {
  const navigate = useNavigate();

  const commonItems = [];

  const adminItems = [
    // {
    //   to: "/",
    //   icon: <FiHome size={15} color="white" />,
    //   label: "Dashboard",
    // },
    {
      to: "/order-list",
      icon: <FiBook size={15} color="white" />,
      label: "Transaction",
    },
    {
      to: "/order-list-hifiair",
      icon: <FiBookOpen size={15} color="white" />,
      label: "Transaction Hifiair",
    },
    {
      to: "/product",
      icon: <FiShoppingBag size={15} color="white" />,
      label: "Product",
    },
    {
      to: "/category",
      icon: <FiGrid size={15} color="white" />,
      label: "Category",
    },
    {
      to: "/user",
      icon: <FiUser size={15} color="white" />,
      label: "User",
    },
    {
      to: "/tenant",
      icon: <FiArchive size={15} color="white" />,
      label: "Tenant",
    },
  ];

  const csItems = [
    {
      to: "/order-list",
      icon: <FiBookOpen size={15} color="white" />,
      label: "Transaction",
    },
    {
      to: "/order-list-hifiair",
      icon: <FiBook size={15} color="white" />,
      label: "Transaction Hifiair",
    },
  ];
  const userItems = [
    {
      to: "/profile",
      icon: <FiHome size={15} color="white" />,
      label: "Profile",
    },
    {
      to: "/add-order",
      icon: <FaAddressBook size={15} color="white" />,
      label: "Create Transaction",
    },
    {
      to: "/add-order/omni",
      icon: <FaAddressBook size={15} color="white" />,
      label: "Create Transaction Omni",
    },
    {
      to: "/transaction",
      icon: <FaListAlt size={15} color="white" />,
      label: "Telkomsel Product",
    },
    {
      to: "/order-list",
      icon: <FiBookOpen size={15} color="white" />,
      label: "Pesanan",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.clear();
    window.location.reload();
    navigate("/login");
  };

  const items = [
    ...commonItems,
    ...(role === "ADMIN" ? adminItems : role === "CS" ? csItems : userItems),
  ];

  return (
    <div>
      {isSidebarOpen && (
        <div
          className={`fixed inset-0 bg-black ${
            role === "ADMIN" || role === "CS" ? "bg-opacity-0" : "bg-opacity-50"
          } z-50`}
          onClick={toggleSidebar}
        ></div>
      )}
      <div
        className={`fixed top-0 left-0 h-full bg-indigo-600 text-white w-64 transform z-50 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        <ul className="mt-20">
          {items.map((item, index) => (
            <SidebarItem
              key={index}
              to={item.to}
              icon={item.icon}
              label={item.label}
              onClick={toggleSidebar} // This will only trigger for "USER" role
              role={role} // Pass the role prop to SidebarItem
            />
          ))}
        </ul>

        <div className="absolute bottom-5 w-full">
          <ul className="mt-20">
            <div
              className="px-4 py-2 items-center cursor-pointer gap-3 flex"
              onClick={handleLogout} // Close sidebar only for USER role
            >
              <FiLogOut size={15} color="white" /> Logout
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};
